export var constants = {
    'add_expense_mode': {
        'hidden': 0,
        'add': 1,
        'edit': 2,
    },

    'booking_actions': {
        'view': 1,
        'add': 2,
        'edit_select': 3,
        'edit_submit': 4,
        'remove': 5,
        'denial': 6,
        'approve': 7,
        'prep': 8,
    },

    'booking_status': {
        'booked': 1,
        'approved': 2,
        'pending_oem': 3,
        'pending_vmh': 4,
        'pending_both': 5,
        'denied': -1,
        'cancelled': -2,
    },

    'booking_type': {
        'profile': 1,
        'service': 2,
        'terminate': 3,
        'user': 4,
    },

    'customer_categories': {
        'vmh_wide': 1,
        'sh_wide': 2,
        'oem_wide': 3,
        'all_cust': 4,
    },

    'customer_category': {
        'Visible ONLY by ': 1,
        'Visible by ALL VMHs and ': 2,
        'Visible by ALL VMHs and ALL ': 3,
    },

    'customer_list_actions': {

        'show': 'show',
        'create': 'create',
        'edit': 'edit',
        'update': 'update',
        'store': 'store',
        'notes_select': 5,
        'notes_submit': 6,
        'activate': 7,
        'deactivate': 8,
        'allow_login': 9,
        'block_login': 10,

    },

    'customer_notes': {
        'vmh_private': 1,
        'sh_private': 2,
        'sh_public': 3,
        'oem_public': 4,
    },

    'general': {
        'remove': 5,
        'denial': 6,
        'approve': 7,
        'prep': 8,
    },

    'invitation_status': {
        'invited': 1,
        'registered': 2,
        'completed': 3,
    },

    'media_tone': {
        'Negative': 0,
        'Somewhat Negative': 25,
        'Neutral': 50,
        'Somewhat Positive': 75,
        'Positive': 100,
    },

    'meta_data': {
        'profile': {
            'regular': {
                'company': 1,
                'title': 2,
            },
            'dealer': {
                'dealer_code': 1,
                'manager': 2,
            },
        },
        'vehilce': {
            'car': {
                'engine': 1,
            },
            'motorcycle': {
                'engine': 1,
            },
        },
    },

    'notification_category': {
        'booking': 1,
        'vehicle': 2,
        'reminder': 3,
    },

    'notifications_type': {
        'new_vehicle': 1,
        'vehicle_terminated': -3,			
        'booking_booked': 1,
        'booking_approved': 2,
        'booking_request_pending_oem': 3,
        'booking_request_pending_vmh': 4,
        'booking_request_pending_both': 5,
        'booking_modified_and_approved': 6,
        'booking_modification_requested': 7,
        'booking_denied': -1,
        'booking_cancelled': -2,
        'booking_modification_denied': -4,	
        'service_due': 1,
        'insurance_due': 2,
        'license_due': 3,
        'termination_due': 4,
        'service_reminder': 5,
        'insurance_reminder': 6,
        'license_reminder': 7,
        'termination_reminder': 8,
    },	

    'prep_status': {
        'storage': 0,
        'prepped': 1,
        'out': 2,
        'returned': 3,
    },

    'prep_status_options': ['Storage', 'Cleaning', 'Ready', 'Out'],

    'provinces': {
        '0': ['Alberta', 'AB'],
        '1': ['British Columbia', 'BC'],
        '2': ['Manitoba', 'MB'],
        '3': ['New Brunswick', 'NB'],
        '4': ['Newfoundland', 'NL'],
        '5': ['Nova Scotia', 'NS'],
        '6': ['Ontario', 'ON'],
        '7': ['PEI', 'PE'],
        '8': ['Quebec', 'QC'],
        '9': ['Saskatchewan', 'SK'],
        '10': ['Northwest Territories', 'NT'],
        '11': ['Nunavut', 'NU'],
        '12': ['Yukon', 'YT'],
    },

    'question_type_page': {
        '1': 'multiple_choice',
        '2': 'textbox',
        '3': 'checkbox',
        '4': 'drop_down',
        '5': 'file_upload',
        '9': 'profile_photo_upload'
    },

    'rank': {
        'admin': 1,
        'temp_admin': 2,
        'user': 3,
        'servicing': 4,
        'dealer': 5,
        'customer_user': 6,
    },

    'reminder_emails': {
        'vehicle_reminder': 1,
        'booking_request': 2,
        'booking_pickup_reminder': 3,
        'booking_dropoff_reminder': 4,
        'booking_late_pickup': 5,
        'booking_late_dropoff': 6,
        'weekly_report': 7,
    },

    'reminder_options': ['Service', 'Insurance', 'License', 'Termination'],

    'sh_divisions': {
        'fleet': 0,
        'public_affairs': 1,
        'sport': 2,
        'integrated': 3,
        'general_pool': 4
    },

    'status_messages': {
        'error': 0,
        'success': 1,
        'warning': 2
    },

    'survey_response': {
        'started': 1,
        'in_progress': 2,
        'completed': 3,
    },

    'time_array': ['12:00', '12:30', '1:00', '1:30', '2:00', '2:30', '3:00', '3:30', '4:00', '4:30', '5:00', '5:30', '6:00', '6:30', '7:00', '7:30', '8:00', '8:30', '9:00', '9:30', '10:00', '10:30', '11:00', '11:30'],

    'unique_code_type': {
        'invitation': 1,
        'booking_approval': 2,
        'booking_rejection': 3,
        'reset_password_link': 4,
        'new_password_link': 5,
        'user_unique_link': 6,
    },

    'userslist_actions': {
        'activate': 1,
        'edit_select': 2,
        'edit_submit': 3,
        'add': 4,
        'disable': 5,
        'remove': 6,
    },

     'user_notifification_method': {
        '0': 'Email',
        '1': 'SMS',
        '2': 'Both',
    },

    'user_request_status': {
        'requested': 1,
        'approved': 2,
        'rejected': 3,
    },

    'user_role': {
        'admin': 1,
        'temp_admin': 2,
        'authorizer': 3,
        'booking_user': 4,
        'viewing_user': 5,
        'detailing_user': 6,
        'customer_profile': 7,
        'dealer': 8,
        'fleet_buyer': 9,
        'media_influencer': 10,
        'employee': 11,
        'integrated_client': 12,
    },

    'user_roles_for_type': {
        'vmh': {
            'admin': 1,
            'temp_admin': 2,
            'authorizer': 3,
            'booking_user': 4,
            'viewing_user': 5,
            'detailing_user': 6,
        },
        'oem': {
            'admin': 1,
            'temp_admin': 2,
            'authorizer': 3,
            'booking_user': 4,
            'viewing_user': 5,
        },
        'user': {
            'dealer': 8,
            'fleet_buyer': 9,
            'media_influencer': 10,
            'employee': 11,
            'integrated_client': 12,
        },
    },

    'user_roles_for_division': {
        'fleet': {
            'fleet_buyer': 9,
            'employee': 11,
        },
        'public_affairs': {
            'media_influencer': 10,
            'employee': 11,
        },
        'sport': {
            'dealer': 8,
            'employee': 11,
        },
        'integrated': {
            'employee': 11,
            'integrated_client': 12,
        },
        'general_pool': {
            'fleet_buyer': 9,
            'media_influencer': 10,
            'employee': 11
        }
    },

    'user_sh_vmh_status': {
        'requested': 1,
        'approved': 2,
        'rejected': 3,
        'disabled': 4,
    },

    'user_status': {
        'invited': 0,
        'registered': 1,
        'survey_answered': 2,
        'approved': 3,
        'rejected': 4,
    },

    'user_type': {
        'god': -1,
        'vmh': 0,
        'oem': 1,
        'user': 2,
    },

    'phone_type': {
        'Default': 1,
		'Mobile': 2,
		'Work': 3,
    },

    // used in vehicle info, vehicle inv, reports
    'vehicle_status': {
        'awaiting': 0,
        'in': 1,
        'prep': 2,
        'out': 3,
        'service': 4,
        'terminated': 5,
    },	

    'vehicle_flags': {
        'electric': 0,
        'awd': 1,
        'leaving_soon': 2,
        'just_added': 3,
        'new_model': 4,
        'hybrid': 5,
        'plug_in_hybrid': 6,
        'major_redesign': 7,
        'winter_tires': 8,
        'prototype': 9
    },

    'vmh_storage_billing': {
        'Annually': 0,
        'Monthly': 1,
        'Weekly': 2,
    },
};